import TableContainer from '@/components/_table-container';
import DeleteData from '@/components/DeleteData';
import LoadingModal from '@/components/_modals/loading';

import SensorLogService from '@/services/SensorLogService';

import { mapState, mapActions } from 'vuex';
import SortList from '../../helpers/SortList';
import { RoleTypes } from "@/constants/role_types";
import UtilsService from "../../services/UtilsService";

export default {
  name: 'NewData',
  components: { TableContainer, DeleteData, LoadingModal },
  data() {
    return {
      data: [],
      tableType: 'sensor',
      debugAbnormal: false,
      fromDate: this.$moment().subtract(2, 'weeks'),
      toDate: null,
      cows: [],
      selectedCows: [],
      selectedBoluses: [],
      searchText: '',
      sortBy: {
        key: null,
        direction: null
      },
      headers: [
        { text: this.$t('cowGenerics.eartag'), sortByKey: 'eartag' },
        { text: this.$t('cowGenerics.cowId'), sortByKey: 'cowID' },
        { text: this.$t('dataPage.createdAt'), sortByKey: 'created_at' },
        {
          text: this.$t('dataPage.databaseEntryTime'),
          sortByKey: 'databaseEntryTime'
        },
        { text: this.$t('bolusGenerics.bolusId'), sortByKey: 'bolusID' },
        { text: this.$t('bolusGenerics.bolusName'), sortByKey: 'bolusName' },
        { text: this.$t('bolusGenerics.deveui'), sortByKey: 'deveui' },
        { text: this.$t('dataPage.tempCount'), sortByKey: 'tempCount' },
        { text: this.$t('graph.lowActivity'), sortByKey: 'lowActivity' },
        { text: this.$t('graph.highActivity'), sortByKey: 'highActivity' },
        {
          text: this.$t('graph.veryHighActivity'),
          sortByKey: 'veryHighActivity'
        },
        { text: this.$t('bolusDetails.battery'), sortByKey: 'battery' },
        { text: 'Lsnr', sortByKey: 'lsnr' },
        { text: 'Rssi', sortByKey: 'rssi' },
        {
          text: this.$t('bolusDetails.coverageLevel'),
          sortByKey: 'coverageLevel'
        },
        { text: 'pendingMsg', sortByKey: 'pendingMsg' },
        { text: 'msgCounter', sortByKey: 'msgCounter' },
        { text: 't1', sortByKey: 'tempFields1' },
        { text: 't2', sortByKey: 'tempFields2' },
        { text: 't3', sortByKey: 'tempFields3' },
        { text: 't4', sortByKey: 'tempFields4' },
        { text: 't5', sortByKey: 'tempFields5' },
        { text: 't6', sortByKey: 'tempFields6' },
        { text: 't7', sortByKey: 'tempFields7' },
        { text: 't8', sortByKey: 'tempFields8' },
        { text: 't9', sortByKey: 'tempFields9' },
        { text: 't10', sortByKey: 'tempFields10' },
        { text: 't11', sortByKey: 'tempFields11' },
        { text: 't12', sortByKey: 'tempFields12' },
        { text: 'ph count', sortByKey: 'phCount' },
        { text: 'phGrouping', sortByKey: 'phGrouping' },
        { text: 'phRaw1', sortByKey: 'phFields1' },
        { text: 'phRaw2', sortByKey: 'phFields2' },
        { text: 'phRaw3', sortByKey: 'phFields3' },
        { text: 'phRaw4', sortByKey: 'phFields4' },
        { text: 'phRaw5', sortByKey: 'phFields5' },
        { text: 'phRaw6', sortByKey: 'phFields6' },
        { text: 'ph1', sortByKey: 'phValue1' },
        { text: 'ph2', sortByKey: 'phValue2' },
        { text: 'ph3', sortByKey: 'phValue3' },
        { text: 'ph4', sortByKey: 'phValue4' },
        { text: 'ph5', sortByKey: 'phValue5' },
        { text: 'ph6', sortByKey: 'phValue6' },
        { text: 'version', sortByKey: 'version' },
        { text: 'status', sortByKey: 'status' },
        { text: this.$t('bolusGenerics.payload'), sortByKey: 'payload' }
      ],
      debugHeaders: [
        { text: this.$t('cowGenerics.eartag'), sortByKey: 'eartag' },
        { text: this.$t('cowGenerics.cowId'), sortByKey: 'cowID' },
        { text: this.$t('dataPage.createdAt'), sortByKey: 'createdAt' },
        {
          text: this.$t('dataPage.databaseEntryTime'),
          sortByKey: 'databaseEntryTime'
        },
        { text: this.$t('bolusGenerics.bolusId'), sortByKey: 'bolusID' },
        { text: this.$t('bolusGenerics.bolusName'), sortByKey: 'bolusName' },
        { text: this.$t('bolusGenerics.deveui'), sortByKey: 'deveui' },
        { text: this.$t('bolusDetails.battery'), sortByKey: 'battery' },
        { text: 'Lsnr', sortByKey: 'lsnr' },
        { text: 'Rssi', sortByKey: 'rssi' },
        { text: this.$t('bolusGenerics.deviceAddress'), sortByKey: 'deviceAddress' },
        { text: this.$t('bolusGenerics.variant'), sortByKey: 'variant' },
        { text: this.$t('bolusGenerics.currentTimestamp'), sortByKey: 'currentTimestamp' },
        { text: this.$t('bolusGenerics.creationTimestamp'), sortByKey: 'creationTimestamp' },
        { text: this.$t('bolusGenerics.pendingMessage'), sortByKey: 'pendingMessage' },
        { text: this.$t('bolusGenerics.totalCommunicationAttempts'), sortByKey: 'totalCommunicationAttempts' },
        { text: this.$t('bolusGenerics.accelerationX'), sortByKey: 'accelerationX' },
        { text: this.$t('bolusGenerics.accelerationY'), sortByKey: 'accelerationY' },
        { text: this.$t('bolusGenerics.accelerationZ'), sortByKey: 'accelerationZ' },
        { text: this.$t('bolusGenerics.failedJoinRequest'), sortByKey: 'failedJoinRequest' },
        { text: this.$t('bolusGenerics.firstJoinAttempt'), sortByKey: 'firstJoinAttempt' },
        { text: this.$t('bolusGenerics.secondJoinAttempt'), sortByKey: 'secondJoinAttempt' },
        { text: this.$t('bolusGenerics.thirdJoinAttempt'), sortByKey: 'thirdJoinAttempt' },
        { text: this.$t('bolusGenerics.fourthJoinAttempt'), sortByKey: 'fourthJoinAttempt' },
        { text: this.$t('bolusGenerics.fifthJoinAttempt'), sortByKey: 'fifthJoinAttempt' },
        { text: this.$t('bolusGenerics.CPUActiveTime'), sortByKey: 'CPUActiveTime' },
        { text: this.$t('bolusGenerics.totalActivityInterrupts'), sortByKey: 'totalActivityInterrupts' },
        { text: this.$t('bolusGenerics.batteryVoltageMedian'), sortByKey: 'batteryVoltageMedian' },
        { text: this.$t('bolusGenerics.sWVersion'), sortByKey: 'sWVersion' },
        { text: this.$t('bolusGenerics.averageRSSI'), sortByKey: 'averageRSSI' },
        { text: this.$t('bolusGenerics.region'), sortByKey: 'region' },
        { text: this.$t('bolusGenerics.lowActivityTreshold'), sortByKey: 'lowActivityTreshold' },
        { text: this.$t('bolusGenerics.highActivityTreshold'), sortByKey: 'highActivityTreshold' },
        { text: this.$t('bolusGenerics.veryHighActivityTreshold'), sortByKey: 'veryHighActivityTreshold' },
        { text: this.$t('bolusGenerics.datarate'), sortByKey: 'datarate' },
        { text: this.$t('bolusGenerics.measInterval'), sortByKey: 'measInterval' },
        { text: this.$t('bolusGenerics.txInterval'), sortByKey: 'txInterval' },
        { text: this.$t('bolusGenerics.retries'), sortByKey: 'retries' },
        { text: this.$t('bolusGenerics.payload'), sortByKey: 'payload' },
      ],
      thiHeaders: [
        { text: this.$t('dataPage.logId'), sortByKey: 'sensor_log_thi_id' },
        { text: this.$t('dataPage.thiSensorId'), sortByKey: 'thi_sensor_id' },
        { text: this.$t('thiSensorGenerics.deveui'), sortByKey: 'deveui' },
        { text: this.$t('dataPage.createdAt'), sortByKey: 'created_at' },
        {
          text: this.$t('dataPage.databaseEntryTime'),
          sortByKey: 'database_entry_time'
        },
        { text: this.$t('thiSensorGenerics.temp'), sortByKey: 'temperature' },
        { text: this.$t('thiSensorGenerics.humidity'), sortByKey: 'humidity' },
        { text: this.$t('thiSensorGenerics.thi'), sortByKey: 'thi' },
        { text: 'Rssi', sortByKey: 'rssi' },
        { text: 'Lsnr', sortByKey: 'lsnr' },
        { text: this.$t('bolusDetails.battery'), sortByKey: 'battery' },
        { text: this.$t('dataPage.sqsMsgId'), sortByKey: 'sqs_msg_id' },
        { text: this.$t('dataPage.sqsMsgInd'), sortByKey: 'sqs_msg_ind' },
        { text: this.$t('bolusGenerics.payload'), sortByKey: 'payload' },
        { text: this.$t('dataPage.sourceType'), sortByKey: 'source_type' },
      ],
      countData: 0,
      debugCountData: 0,
      pagination: {
        sortBy: 'databaseEntryTime',
        descending: true,
        rowsPerPage: 100
      },
      init: true,
      error: null,
      search: null,
      loading: false,
      deleteDataModal: false,
      RoleTypes: RoleTypes
    };
  },
  mounted() {
    this.getCows({include_archived: true, include_deleted: true, include_culled: true});
    this.listBoluses();
    this.querySensorLogs();
  },
  destroyed() {
    this.clearCows();
    this.clearBoluses();
    this.clearSensorLogs();
    this.clearDebugSensorLogs();
    this.clearThiSensorLogs();
  },
  methods: {
    ...mapActions('sensorLogs', {
      getSensorLogs: 'getSensorLogs',
      getDebugSensorLogs: 'getDebugSensorLogs',
      getThiSensorLogs: 'getThiSensorLogs',
      clearSensorLogs: 'clearSensorLogs',
      clearDebugSensorLogs: 'clearDebugSensorLogs',
      clearThiSensorLogs: 'clearThiSensorLogs',
      showLoadingModal: 'showLoadingModal',
      hideLoadingModal: 'hideLoadingModal'
    }),
    ...mapActions('cows', {
      getCows: 'getCows',
      clearCows: 'clearCows'
    }),
    ...mapActions('boluses', {
      listBoluses: 'listBoluses',
      clearBoluses: 'clear'
    }),
    querySensorLogs() {
      if (!this.validateRange())
        return;
      if (this.tableType === 'sensor') {
        this.getSensorLogs({
          limit: this.pagination.rowsPerPage,
          cowIDs: this.selectedCows,
          bolusIDs: this.selectedBoluses,
          fromDate: this.fromDate.format(),
          toDate: this.toDate ? this.toDate.format() : null,
        });
      } else if (this.tableType === 'thi') {
        this.getThiSensorLogs({
          limit: this.pagination.rowsPerPage,
          fromDate: this.fromDate.format(),
          toDate: this.toDate ? this.toDate.format() : null,
        });
      } else {
        this.getDebugSensorLogs({
          limit: this.pagination.rowsPerPage,
          cowIDs: this.selectedCows,
          bolusIDs: this.selectedBoluses,
          fromDate: this.fromDate.format(),
          toDate: this.toDate ? this.toDate.format() : null,
          abnormalOnly: this.debugAbnormal
        });
      }
    },
    searchSensorLogs(searchText, data) {
      if (!searchText || searchText === '') {
        return data;
      }
      const searchedData = [];
      data.forEach(cow => {
        if (
          Object.values(cow).some(
            item =>
              item &&
              item
                .toString()
                .toLowerCase()
                .includes(searchText.toLowerCase())
          )
        ) {
          searchedData.push(cow);
        }
      });
      return searchedData;
    },
    mergeSensorLogsWithBolus(sensorLogs, bolusList) {
      if (sensorLogs) {
        let returnSensorLogs = sensorLogs.map(s => {
          const bolus = bolusList.find(b => b.bolus_id == s.bolus_id);
          const newS = { ...s }
          if (bolus) {
            newS.deveui = bolus.deveui;
            newS.bolusName = bolus.bolus_name;
          }
          return newS;
        });
        return returnSensorLogs;
      }
      return null;
    },
    sortData(sensorLogs, sortBy) {
      let sortedSensorLogs = sensorLogs && sensorLogs.map(ssl => ssl);
      if (sortBy && sortBy.key) {
        sortedSensorLogs = SortList(sortedSensorLogs, sortBy);
      }
      return sortedSensorLogs;
    },
    setSortBy(sortBy) {
      this.sortBy.direction =
        !this.sortBy.direction || this.sortBy.key !== sortBy ? true : false;
      this.sortBy.key = sortBy;
    },
    formatPayload(payload) {
      if (!payload) {
        return '';
      }

      let tempPayload = payload.split('"data":"')[1];
      if (tempPayload) {
        tempPayload = tempPayload.split('"')[0];
      } else {
        tempPayload = payload.split('"Payload": "')[1];
        if (tempPayload) {
          tempPayload = tempPayload.split('"')[0];
        }
      }

      if (!tempPayload) {
        return payload;
      }


      return tempPayload;

    },
    async getCsv() {
      if (!this.validateRange())
        return;
      this.showLoadingModal();
      this.loading = true;

      let response;
      let fileName;
      const dateSuffix = `${this.fromDate.format("YYYY-MM-DD HH:mm")}-${this.toDate && this.toDate.format("YYYY-MM-DD HH:mm") || this.$moment().format("YYYY-MM-DD HH:mm")}`;

      if (this.tableType === 'thi') {
        response = await SensorLogService.csvThiDownload(
          this.fromDate.format(),
          this.toDate ? this.toDate.format() : null
        );
        fileName = `sensor_log_thi_${dateSuffix}.csv`;
      } else {
        response = await SensorLogService.csvDownload(
          this.fromDate.format(),
          this.toDate ? this.toDate.format() : null,
          this.selectedCows,
          this.selectedBoluses
        );
        fileName = `sensorLog_${dateSuffix}.csv`;
      }

      UtilsService.downloadCsv(response.data, fileName);

      this.loading = false;
      this.hideLoadingModal()
    },
    async getCsvPh() {
      if (!this.validateRange())
        return;
      this.showLoadingModal();
      this.loading = true;
      const response = await SensorLogService.csvPhDownload(
        this.fromDate.format(),
        this.toDate ? this.toDate.format() : null,
        this.selectedCows,
        this.selectedBoluses
      );

      UtilsService.downloadCsv(response.data, `sensorLog_ph_${this.fromDate.format("YYYY-MM-DD HH:mm")}-${this.toDate && this.toDate.format("YYYY-MM-DD HH:mm") || this.$moment().format("YYYY-MM-DD HH:mm")}.csv`)

      this.loading = false;
      this.hideLoadingModal()
    },
    async getCsvDebug() {
      if (!this.validateRange())
        return;
      this.showLoadingModal();
      this.loading = true;
      const response = await SensorLogService.csvDebugDownload(
        this.fromDate.format(),
        this.toDate ? this.toDate.format() : null,
        this.selectedCows,
        this.selectedBoluses
      );

      UtilsService.downloadCsv(response.data, `debug_sensorLog_${this.fromDate.format("YYYY-MM-DD HH:mm")}-${this.toDate && this.toDate.format("YYYY-MM-DD HH:mm") || this.$moment().format("YYYY-MM-DD HH:mm")}.csv`);

      this.loading = false;
      this.hideLoadingModal();
    },
    async getCsvCowLog() {
      if (!this.validateRange())
        return;
      this.showLoadingModal();
      this.loading = true;
      const response = await SensorLogService.csvCowLog(
        this.fromDate.format(),
        this.toDate ? this.toDate.format() : null,
        this.selectedCows
      );

      UtilsService.downloadCsv(response.data, `cow_logs_${this.fromDate.format("YYYY-MM-DD HH:mm")}-${this.toDate && this.toDate.format("YYYY-MM-DD HH:mm") || this.$moment().format("YYYY-MM-DD HH:mm")}.csv`);

      this.loading = false;
      this.hideLoadingModal();
    },
    validateRange() {
      const toDate = this.toDate || this.$moment();
      const fromDate = this.$moment(this.fromDate);

      this.error = null;
      if (toDate.diff(fromDate, 'days') > 31) {
        this.error = this.$t('mainErrors.dateRange1Month');
        return false;
      }
      return true;
    },
    showMore() {
      this.pagination.rowsPerPage += 100;
      this.querySensorLogs();
    },
    clear() {
      this.pagination.rowsPerPage = 100;
      this.querySensorLogs();
    },
    formatDate(date) {
      if (!date)
        return '';
      return this.$moment(date).format(this.$dateTimeFormat);
    },
    formatNumber(num, digit) {
      if (typeof num === 'string') {
        return '';
      }
      return num && num.toFixed(digit);
    },
    selectAllCow() {
      this.selectedCows = []
      this.cowList.forEach(cow => {
        this.selectedCows.push(cow['cow_id'])
      })
    },
    selectAllBolus() {
      this.selectedBoluses = []
      this.bolusList.forEach(bolus => {
        this.selectedBoluses.push(bolus['bolus_id'])
      })
    },
    clearAllCow() {
      this.selectedCows = []
    },
    clearAllBolus() {
      this.selectedBoluses = []
    }
  },
  computed: {
    ...mapState({
      /**
       * The computed data for the table
       * @param {object} state The state object
       */
      sensorLogList(state) {
        const filteredSensorLogs = this.searchSensorLogs(
          this.searchText,
          state.sensorLogs.data
        );
        const mergedSensorLogs = this.mergeSensorLogsWithBolus(
          filteredSensorLogs,
          this.bolusList
        );
        const sortedSensorLogs = this.sortData(mergedSensorLogs, this.sortBy);
        return sortedSensorLogs;
      },
      debugSensorLogList(state) {
        const filteredSensorLogs = this.searchSensorLogs(
          this.searchText,
          state.sensorLogs.debugData
        );
        const sortedSensorLogs = this.sortData(filteredSensorLogs, this.sortBy);
        return sortedSensorLogs;
      },
      thiSensorLogList(state) {
        const filteredSensorLogs = this.searchSensorLogs(
          this.searchText,
          state.sensorLogs.thiData
        );
        const sortedSensorLogs = this.sortData(filteredSensorLogs, this.sortBy);
        return sortedSensorLogs;
      },
      sensorLogCount: state => state.sensorLogs.data.count,
      cowList: state => state.cows.cows,
      bolusList: state => state.boluses.boluses,
      isFetching: state => state.sensorLogs.isFetching,
    }),
    sortedCowList() {
      return this.cowList.slice().sort((a, b) => {
        if (a.eartag < b.eartag) {
          return -1;
        }
        if (a.eartag > b.eartag) {
          return 1;
        }
        return 0;
      });
    }
  },
  watch: {
    debugAbnormal: {
      async handler() {
        this.getDebugSensorLogs({
          limit: this.pagination.rowsPerPage,
          // orderBy: this.pagination.sortBy,
          // descending: this.pagination.descending,
          cowIDs: this.selectedCows,
          bolusIDs: this.selectedBoluses,
          fromDate: this.fromDate,
          toDate: this.toDate,
          abnormalOnly: this.debugAbnormal
        });
      }
    },
    tableType: {
      async handler() {
        this.querySensorLogs();
      }
    },
    deep: true,
    selectedCowsIds: {

    }
  }
};



// WEBPACK FOOTER //
// ./src/components/_data/data.js